import { KeyboardArrowDownRounded } from '@mui/icons-material';
import { alpha, Select, SelectProps, SxProps, Theme } from '@mui/material';

const customStyles: SxProps<Theme> = {
  borderRadius: '8px',
  '&.Mui-disabled': {
    backgroundColor: '#F3F5F9',
  },
  '& .MuiSelect-select': {
    padding: '6px 40px 6px 12px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
    border: (theme: Theme) => `1px solid ${theme.palette.secondary.light}`,
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme: Theme) => theme.palette.primary.main,
    },
  },
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
      boxShadow: (theme: Theme) => `0 0 0 2px ${alpha(theme.palette.primary.main, 0.1)}`,
      outline: 'none',
    },
  },
};

export function SingleSelect(props: SelectProps) {
  return (
    <Select
      {...props}
      sx={{ ...customStyles, ...props.sx } as SxProps<Theme>}
      IconComponent={(props) => (
        <KeyboardArrowDownRounded
          fontSize='small'
          {...props}
        />
      )}
    ></Select>
  );
}
